import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { PermissionDTO } from '../PermissionDTO';

/**
 * Resolves whether the user is denied access to a permission ("has no access").
 *
 * When the permissions payload is loaded (web + carrier TMS webview) we trust
 * it. Otherwise we keep the legacy "allow inside the native app" fallback used
 * where the permissions endpoint isn't called (e.g. loadboard mobile webview).
 *
 * Shared by `usePermissionAccess` and `usePermissionAccessGroup` so both stay
 * consistent.
 */
export function resolveHasNoAccess(
  userPermission: PermissionDTO | undefined,
  hasUserPermission: boolean | undefined,
): boolean {
  if (userPermission) {
    return !hasUserPermission;
  }

  return !hasUserPermission && !MobileAppBridge.isInjected();
}
